import React from "react";
import { FolioNonUpdateContainer } from "../../container/panelReports";

const ConnectorStatusScreen: React.FC<{}> = () => {
  return <FolioNonUpdateContainer/>;
}

export default ConnectorStatusScreen;